export class UnderwritingExpressionDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getExpressionDefinition() {
    return this.#http.get('/expressionDefinition');
  }
}
